import * as React from "react";
import { useAdyen } from "../../../../../../../../../../../../context/Adyen/context/Adyen/context.js";
import { AdyenBrands, PaymentMethod } from "../../../../../../../../../../../../models/cart-payment-methods/models/cart-payment-methods/cart-payment-methods.js";
import { CreditCardContainer } from "../../../../../../../../../../containers/Adyen/CreditCard/modules/PaymentMethodsList/containers/Adyen/CreditCard/CreditCardContainer.js";
const Creditcard = ({ onChange, config: paymentConfig }) => {
  const { config } = useAdyen();
  const creditcardConfig = React.useMemo(() => {
    const configData = config?.creditcard;
    if (configData && paymentConfig?.brands) {
      configData.brands = paymentConfig?.brands;
    }
    return configData;
  }, [config, paymentConfig]);
  const handleChange = React.useCallback(
    (state) => {
      let paymentMethodType;
      if (state.cardBrand === AdyenBrands.BANCONTACTMC) {
        paymentMethodType = PaymentMethod.BANCONTACT_CARD;
      }
      onChange(state.data, state.isValid, paymentMethodType);
    },
    [onChange]
  );
  return /* @__PURE__ */ React.createElement(CreditCardContainer, { onChange: handleChange, additionalOptions: creditcardConfig });
};
export {
  Creditcard
};
//# sourceMappingURL=Creditcard.js.map
